export default "__VITE_ASSET__C9ik$DRg__"